import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import { mediaTopBarVisible } from '@xing-com/layout-tokens';
import { spaceXXL } from '@xing-com/tokens';

const StyledTextButton = styled(TextButton)`
  margin-top: ${spaceXXL};

  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

export const Styled = {
  TextButton: StyledTextButton,
};
